<template>
  <van-popup
    closeable
    close-icon="close"
    get-container="#app"
    :show="show"
    @click-close-icon="onClickCloseIcon"
    :style="{
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      borderRadius: '10px',
      background: 'white',
      alignItems: 'center',
    }"
  >
    <van-form class="form-content" @submit="onSubmit">
      <div class="form-field">
        <!-- <div class="title">昵称<span class="star"> * </span></div>
        <van-field
          v-model="nickname"
          class="field"
          name="nickname"
          placeholder="请填写昵称"
          :rules="[{ required: true, message: '请填写昵称' }]"
        /> -->
        <div class="title">个人简介<span class="star"> * </span></div>
        <van-field
          v-model="sub_content"
          class="field"
          name="content"
          required
          rows="5"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请写下您的个人简介"
          show-word-limit
          :rules="[{ required: true, message: '请写下您的个人简介' }]"
        />
      </div>
      <van-button
        class="submit-btn button glass"
        type="default"
        round
        color="linear-gradient(to right, #f56c42, #feb91f)"
        native-type="submit"
        :loading="loading"
        loading-text="提交中..."
      >
        提交
      </van-button>
    </van-form>
  </van-popup>
</template>

<script>
import { Popup, Form, Button, Field, Uploader } from "vant";
import { Toast } from "@vant/compat";
import { ref, toRef } from "vue";
import Api from "../api";
export default {
  name: "IntroductionForm",
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup,
  },
  props: { content: String },
  emits: ["setContent", "update:show"],
  setup(props, context) {
    // const nickname = ref("");
    // if (localStorage.getItem("nickName"))
    //   nickname.value = localStorage.getItem("nickName");
    const loading = ref(false);
    const show = toRef(props, "showForm");
    const sub_content = ref(props.content);
    const onSubmit = (values) => {
      if (values.comment == "") {
        Toast.fail("个人简介不得为空");
        return;
      }
      const params = {
        personal_profile: values.content,
      };
      Api.updatePersonalProfile(params).then(() => {
        context.emit("update:show", false);
        context.emit("setContent", values.content);
      });
    };
    const onClickCloseIcon = () => {
      context.emit("update:show", false);
    };

    return {
      // nickname,
      onSubmit,
      loading,
      show,
      sub_content,
      onClickCloseIcon,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  width: 80%;
  margin-top: 30px;
}
.form-field {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
}
.form-input {
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.2);
}

.submit-btn {
  width: 50%;
  margin-top: 20px;
  margin-bottom: 10px;
}

.field {
  // border-radius: 10px;
  // --van-cell-background-color: rgb(245, 247, 250);
  // margin-bottom: 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 10px;
  background-color: rgba(255, 255, 255, 0.2);
}
.title {
  font-size: 1em;
  margin-left: 2px;
  margin-top: 10px;
  .star {
    color: red;
  }
}
</style>
